import React from "react";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";
import Autocomplete from "Components/UI/Form/Autocomplete";

export default function EndcustomersComboBox({
  label,
  disabled,
  endcustomers,
  selectedEndcustomerID,
  onChange,
}) {
  const navigate = useNavigate();

  return (
    <Autocomplete
      value={
        endcustomers
          ? endcustomers.find((ec) => ec.Id === selectedEndcustomerID)
          : null
      }
      disabled={disabled}
      options={endcustomers ? endcustomers : []}
      getOptionLabel={(ec) => ec.Name + "-" + ec.Id}
      isOptionEqualToValue={(option, value) => {
        return option.Id === value?.Id || value == null;
      }}
      onChange={(event, newValue) => {
        onChange(newValue == null ? null : newValue.Id);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  display: selectedEndcustomerID != null ? "flex" : "none",
                }}
              >
                <IconButton
                  onClick={() =>
                    navigate(`/endcustomers/${selectedEndcustomerID}`)
                  }
                  edge="end"
                >
                  {<LinkIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          label={label ? label : ""}
        />
      )}
    />
  );
}
